import React, { Component, lazy, Suspense } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { Container, Alert } from "react-bootstrap";
import { Offline } from "react-detect-offline";
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleRight, faAngleLeft, faAngleDoubleRight, faAngleDoubleLeft,
  faAngleDown, faAngleUp,
  faSearch,
  faTrash, faClock
} from '@fortawesome/free-solid-svg-icons';

// import { DeviceControl, ControlDevice } from "./Routes/DeviceControl";
import Login from "./Routes/Login";
import Home from "./Routes/Home";
import Header from "./Elements/Header";
import Footer from "./Elements/Footer";
import Error from "./Routes/Error";
import LoadingMessage from "./Elements/LoadingMessage";

library.add(faAngleRight, faAngleLeft, faAngleDoubleRight, faAngleDoubleLeft, faAngleDown, faAngleUp, faSearch, faTrash, faClock);

const DeviceView = lazy(() => import("./Routes/DeviceView"));
const ClientControl = lazy(() => import("./Routes/ClientControl"));
const UserMng = lazy(() => import("./Routes/UserMng"));
const ShowDevice = lazy(() => import("./Routes/ShowDevice"));
const DeviceSetup = lazy(() => import("./Routes/DeviceSetup"));
const Profile = lazy(() => import("./Routes/Profile"));
const Contact = lazy(() => import("./Routes/Contact"));
const Legal = lazy(() => import("./Routes/Legal"));
const ResolvesInfo = lazy(() => import("./Routes/ResolvesInfo"));

// const DeviceControl = lazy(() => import("./Routes/DeviceControl"));
const ControlDevice = lazy(() => import("./Routes/ControlDevice"));

// const LoadingMessage = () => "I'm loading...";

class App extends Component {
  state = {
    userName: undefined,
    client: 0,
    uid: 0,
    userMng: 0,
    jwt: undefined,
    controlClient: undefined
  };

  componentDidMount(){
    const jwtToken = sessionStorage.getItem("jwt");
    const userId = parseInt(sessionStorage.getItem("user"));
    const clientId = parseInt(sessionStorage.getItem("client"));
    const isUserMng = parseInt(sessionStorage.getItem("userMng"));

    if (jwtToken) {
        this.setState({ 
          isAuthenticated: true,
          jwt: jwtToken,
          uid: userId,
          client: clientId,
          userMng: isUserMng
         });
    }
  }

  updateJWT = obj => {
    const jwtToken = obj.jwt;
    const userId = parseInt(obj.decoded.uid);
    const clientId = parseInt(obj.decoded.client);
    const isUserMng = parseInt(obj.decoded.userMng);

    // Save the token to sessionStorage
    sessionStorage.setItem("jwt", jwtToken);
    sessionStorage.setItem("user", userId);
    sessionStorage.setItem("client", clientId);
    sessionStorage.setItem("userMng", isUserMng);

    // this.setState({ jwt: obj.jwt, decoded: obj.decoded });
    this.setState({
      uid: userId,
      client: clientId,
      userMng: isUserMng,
      jwt: jwtToken
    });
  };

  handleLogout = () => {
    console.log("Log Out");

    // Clear token from storage
    sessionStorage.removeItem("jwt");
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("client");
    sessionStorage.removeItem("userMng");

    this.setState({ 
      isAuthenticated: false,
      userName: undefined,
      client: 0,
      uid: 0,
      userMng: 0,
      jwt: undefined,
      controlClient: undefined
     });
  };

  updateCC = cc => this.setState({ controlClient: cc });

  render() {
    // console.log(process.env.REACT_APP_STAGE);

    return (
      <BrowserRouter>
        <div className="App">
          <Header
            uid={this.state.uid}
            client={this.state.client}
            userMng={this.state.userMng}
            handleLogout={this.handleLogout.bind(this)}
          />
           {/* <Offline>
           <Container className="mb-4">
           <Alert variant={"danger"}>Network Disconnected ! ! !</Alert>
           </Container>
           </Offline> */}
          <Container style={{ marginTop: "10px" }}>
            <Suspense fallback={<LoadingMessage />}>
              <Switch>
                <Route
                  path="/deviceView"
                  render={props => (
                    <DeviceView {...props} jwt={this.state.jwt} vc="v" />
                  )}
                />
                <Route
                  path="/deviceControl"
                  render={props => (
                    // <DeviceControl {...props} jwt={this.state.jwt} vc="c"/>
                    <DeviceView {...props} jwt={this.state.jwt} vc="c" />
                  )}
                />
                <Route
                  path="/ControlDevice"
                  render={props => (
                    <ControlDevice
                      {...props}
                      jwt={this.state.jwt}
                      clientID={this.state.client}
                    />
                  )}
                />
                <Route
                  path="/ClientControl"
                  render={props => (
                    <ClientControl
                      {...props}
                      jwt={this.state.jwt}
                      controlClient={this.state.controlClient}
                    />
                  )}
                />
                <Route
                  path="/Login"
                  render={props => (
                    <Login {...props} updateJWT={this.updateJWT.bind(this)} />
                  )}
                />
                <Route
                  path="/userMng"
                  render={props => (
                    <UserMng
                      {...props}
                      jwt={this.state.jwt}
                      updateCC={this.updateCC}
                    />
                  )}
                />
                {/* <Route
                path="/System"
                render={props => <UserMng {...props} jwt={this.state.jwt} />}
              /> */}
                <Route
                  path="/profile"
                  render={props => (
                    <Profile
                      {...props}  /* this needs to be checked out. if it's needed */
                      jwt={this.state.jwt}
                      updateJWT={this.updateJWT.bind(this)}
                    />
                  )}
                />
                <Route
                  path="/ShowDevice"
                  render={props => (
                    <ShowDevice
                      {...props}
                      userID={this.state.uid}
                      jwt={this.state.jwt}
                    />
                  )}
                />
                <Route
                  path="/DeviceSetup"
                  render={props => (
                    <DeviceSetup {...props} jwt={this.state.jwt} />
                  )}
                />
                <Route
                  path="/ResolvesInfo"
                  render={props => (
                    <ResolvesInfo {...props} />
                  )}
                />
                <Route path="/" component={Home} exact />
                {/* <Route path="/oxyspa" component={Home} /> */}
                <Route path="/Contact" component={Contact} />
                <Route path="/legal" component={Legal} />
                <Route component={Error} />
              </Switch>
            </Suspense>
          </Container>
          {/* <Offline>
            <Container className="mb-4">
              <Alert variant={"danger"}>Network Disconnected ! ! !</Alert>
            </Container>
          </Offline> */}
          <Footer />
        </div>
      </BrowserRouter>
    );
  }
}

export default App;
